import type { ReactNode } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { HubSpotTracking } from "./HubSpotTracking";
import { StickyCta } from "./StickyCta";
import { I18nProvider, type LocaleCode } from "@/i18n";
import { accessibilityCopy } from "@/i18n/accessibility";

export function SiteShell({ children, locale }: { children: ReactNode; locale: LocaleCode }) {
  return (
    <I18nProvider initialLocale={locale}>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[70] focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-accent-foreground"
      >
        {accessibilityCopy[locale].skip}
      </a>
      <Header />
      <main id="main" tabIndex={-1}>
        {children}
      </main>
      <Footer />
      <StickyCta />
      <HubSpotTracking />
    </I18nProvider>
  );
}
